<template>
  <div class="log-header">
    <div class="log-img">
      <gj-image :src="imageUrl" :size="60"></gj-image>
    </div>
    <div>
      <el-row type="flex">
        <div style="margin-right: 40px">
          <span class="gj-label font12">店铺/国家：</span>
          <span class="gj-content font12">{{marketId | optionText(marketOption) | defaultShow}}</span>
        </div>
        <div v-if="dimension === OperationLogEnum.dimension.ASIN">
          <span class="gj-label font12">ASIN：</span>
          <span class="gj-content font12">{{asin | defaultShow}}</span>
        </div>
      </el-row>
      <div>
        <span class="gj-label font12">父ASIN：</span>
        <span class="gj-content font12">{{variationAsin | defaultShow}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import {OperationLogEnum} from "../../../common/enum";

  export default {
    name: "app-view-operation-log-header",
    props: {
      variationAsin: {
        type: String
      },
      asin: {
        type: String
      },
      dimension: {
        required: true
      },
      marketId: {
        required: true,
      },
      imageUrl: {
        required: true
      }
    },
    data() {
      return {
        OperationLogEnum: OperationLogEnum
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    }
  }
</script>

<style scoped>
  .log-header {
    height: 80px;
    display: flex;
    align-items: center;
  }
  .log-img {
    margin-right: 20px;
  }
</style>
